import { render, staticRenderFns } from "./dialogEdit.vue?vue&type=template&id=37e1a6d4&scoped=true&"
import script from "./dialogEdit.vue?vue&type=script&lang=js&"
export * from "./dialogEdit.vue?vue&type=script&lang=js&"
import style0 from "./dialogEdit.vue?vue&type=style&index=0&id=37e1a6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1a6d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VSpacer,VTextField})
